import { LOGOUT, REHYDRATE, CHOOSE_COMPANY } from "@Actions/types";

export default function reducer(
	state = {
		quickAnswers: [],
	},
	action
) {
	const { payload, type } = action;
	switch (type) {
		case LOGOUT: {
			return {
				...state,
				quickAnswers: [],
			};
		}

		case REHYDRATE: {
			return {
				...state,
				quickAnswers: payload.data.quickAnswers.quickAnswers,
			};
		}

		case CHOOSE_COMPANY: {
			return {
				...state,
				quickAnswers: payload.data.company.quickAnswers,
			};
		}

		default:
			return state;
	}
}
